import {
  IonButton,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonPage,
  IonRow,
} from "@ionic/react";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import ExerciseCard from "../components/ExerciseCard";
import TopLeftUserName from "../components/TopLeftUserName";
import {
  allExercisesState,
  duplicateExercisePlanState,
  newDuplicateExercisePlanState,
  fixedAllExercisesState,
  isDuplicateCalledState,
  tempAllExercisesState,
  PatientState,
} from "../data/atoms";
import { sortTests } from "../utils/sharedFunction";
import { PatientVM } from "../models/PatientVM";

interface Props {
  exercisesRecommendationHistory: any;
}
const AssignExercise: React.FC<Props> = ({
  exercisesRecommendationHistory,
}) => {
  debugger;
  let history = useHistory();

  const [exerciseRecentSearches, setExerciseRecentSearches] = useState<any[]>([
    "Exercise1",
    "Exercise2",
    "Exercise3",
  ]);
  const [previousExercise, setPreviousExercise] = useRecoilState(
    duplicateExercisePlanState
  );
  const [oldpreviousExercise] = useState(
    JSON.parse(JSON.stringify(previousExercise))
  );
  // const previousExercise = useRecoilValue(newDuplicateExercisePlanState);
  const [buttonsFooter, showButtonsFooter] = useState(false);
  const [allExercises, setAllExercisesState] =
    useRecoilState(allExercisesState);
  const [fixedExercisesCount, setFixedExercisesCount] = useRecoilState(
    fixedAllExercisesState
  );
  const [isDuplicateCalled, setIsDuplicateCalled] = useRecoilState(
    isDuplicateCalledState
  );

  const [allExercisesFilter, setAllExercisesFilterState] =
    useRecoilState(allExercisesState);
  const [tempAllExercises, setTempAllExercises] = useRecoilState(
    tempAllExercisesState
  );

  const [sortArr, setSortArr] = useState<any[]>([]);

  const [patientDetailsRecoil, setPatientDetailsRecoil] =
    useRecoilState(PatientState);

  const [patientDetails, setPatientDetails] =
    useState<PatientVM>(patientDetailsRecoil);

  useEffect(() => {
    setIsDuplicateCalled(false);
  }, []);

  useEffect(() => {
    // Clone the array to avoid mutating state directly
    const clonedArr: any = [...fixedExercisesCount.exercises];

    //take out the ids from previousExercise
    let selectedIds = previousExercise.exercises.map(
      (exercise: any) => exercise.testExercises[0].id
    );

    console.log("selectedIds", selectedIds);

    const sortArr = sortTests(clonedArr, selectedIds);

    console.log("sortArr", sortArr);

    setTempAllExercises((prevState: any) => ({
      exercises: sortArr,
    }));
  }, []);

  const HideShowFooter = async (hideShow: boolean) => {
    showButtonsFooter(hideShow);
  };

  const UpdateSelectedExercises = () => {
    let selectedExercises: number[] = [];
    previousExercise.exercises.map((exercise: any) => {
      selectedExercises.push(exercise.testExercises[0].id);
    });

    return selectedExercises;
  };

  const revertSelectedExercise = () => {
    debugger;
    setPreviousExercise((prevState: any) => ({
      ...prevState,
      exercises: oldpreviousExercise.exercises,
    }));
    debugger;
    let visitId = 0;
    let historyObj =
      exercisesRecommendationHistory?.exercisesRecommendationHistory
        .exercisesRecommendationHistory;
    historyObj?.map((exercise: any) => {
      oldpreviousExercise.exercises.map((oldExercise: any) => {
        if (exercise.exercisesId.includes(oldExercise.testExercises[0].id)) {
          visitId = exercise.visitId;
        }
      });
    });
    const combinedObject = {
      visitId: visitId,
      exercisesRecommendationHistory: historyObj,
      recommendationDate:
        exercisesRecommendationHistory.exercisesRecommendationHistory
          .recommendationDate,
    };
    history.push("/duplicate-exercise", {
      visitData: combinedObject,
    });
  };

  useEffect(() => {}, [previousExercise]);

  return (
    <>
      <IonPage placeholder={undefined} className="page">
        <TopLeftUserName
          headerText={"Add More Exercises"}
          revertSelectedExercise={revertSelectedExercise}
        ></TopLeftUserName>
        <IonContent
          scroll-y="true"
          placeholder={undefined}
          className="full-visit-summary-main-page slide-in-right"
        >
          <IonGrid
            className="container full-visit-summary-page"
            placeholder={undefined}
          >
            <IonRow className="row" placeholder={undefined}>
              <IonCol className="col-sec" placeholder={undefined}>
                <ExerciseCard
                  exercisesList={fixedExercisesCount}
                  hideShowFooter={HideShowFooter}
                  selectedExercisesid={UpdateSelectedExercises()}
                  previousExercises={previousExercise}
                  isDuplicatePlanCalled={false}
                  isRTMEnabled={patientDetails.isPatientRTMEnabled}
                ></ExerciseCard>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
        {(buttonsFooter || previousExercise.exercises.length > 0) && (
          <IonFooter
            className="ion-no-border duplicate-ex-page-footer"
            placeholder={undefined}
          >
            <IonGrid className="container" placeholder={undefined}>
              <IonRow className="row" placeholder={undefined}>
                <IonCol className="col-sec" placeholder={undefined}>
                  <div className="two-col-btn">
                    <IonButton
                      placeholder={undefined}
                      className="blue-outline-btn"
                      onClick={() => {
                        setPreviousExercise((prevState: any) => ({
                          ...prevState,
                          exercises: oldpreviousExercise.exercises,
                        }));
                        history.replace("/duplicate-exercise");
                      }}
                    >
                      Cancel
                    </IonButton>
                    <IonButton
                      placeholder={undefined}
                      className="blue-btn"
                      onClick={() => history.replace("/review-exercises")}
                    >
                      Next
                    </IonButton>
                  </div>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonFooter>
        )}
      </IonPage>
    </>
  );
};
export default AssignExercise;
